import { RibbonRequest } from './RibbonRequest';
import { Log } from '@lightningjs/sdk';
import { CmsGrid } from '../../components/cms/CmsGrid';
import { CardSizeInfo } from './CardSizeInfo';
import { CardDataSource } from './CardDataSource';
import { CardType } from '../../api/models/Shared.types';
import { LLDataSource } from './LLDataSource';
import { Backend } from '../../api/Backend';
import { ICustomCmsGrid, IRibbon2Asset } from '../../api/models/AndromeTV.types';
import { ChannelModel } from '../../api/EpgApi.types';

const _constants = {
  firstLoadAmount: 10,
  loadAmountPortrait: 5,
  loadAmountLandscape: 4,
};

export class GridDataSource extends LLDataSource {
  private grid: ICustomCmsGrid;
  protected cmsProperties: string[];
  protected channels: ChannelModel[];
  private data: null;
  protected sizeInfo: CardSizeInfo;
  private title: string | undefined;
  private ribbonRequest: RibbonRequest | undefined;
  private message = false;

  constructor(backend: Backend, grid: ICustomCmsGrid, pageProperties: string[], channels: ChannelModel[]) {
    super(backend, _constants.firstLoadAmount, _constants.loadAmountPortrait);
    this.grid = grid;
    this.cmsProperties = this.combineProperties(grid.properties, pageProperties);
    this.channels = channels;
    this.data = null;
    this.sizeInfo = new CardSizeInfo(true);
    this.hasNextPage = true;
    this.title = grid.title;
  }

  /**
   * Load the first page of the ribbon
   */
  override load(): Promise<GridDataSource> {
    const fetchPagePromise = this._fetchPage(this.pageIdx);
    return fetchPagePromise.then(() => {
      this.pageIdx += 1;
      return this;
    });
  }

  /**
   * Load the next items of the grid
   */
  override loadNext(): Promise<CardDataSource[]> {
    this.loadAmount =
      this.sizeInfo.cardType === CardType.Landscape ? _constants.loadAmountLandscape : _constants.loadAmountPortrait;
    return super.loadNext();
  }

  _fetchPage(pageIdx: number): Promise<GridDataSource> {
    return new Promise(resolve => {
      if (!this.hasNextPage) {
        resolve(this);
        return;
      }
      // console.log('GRID data source', this.grid);
      if (!this.ribbonRequest) {
        this.ribbonRequest = new RibbonRequest(this.backend, this.grid, this.channels);
      }
      this.ribbonRequest.pageIdx = pageIdx;
      this.ribbonRequest
        .load()
        .then(data => {
          // console.log('load succeeded', data);
          if (data) {
            this.sizeInfo.updateWithContainer(data, this.cmsProperties);
            if (data.items) {
              this.items = this.items.concat(
                data.items.map(
                  (card: IRibbon2Asset) =>
                    new CardDataSource(this.backend, card, this.sizeInfo, this.cmsProperties, this.channels)
                )
              );
            }
            this.hasNextPage = data.nextPage;
          }
          resolve(this);
        })
        .catch(err => {
          Log.error(`Error fetching ${this.grid.url}: ${err}`);
          resolve(this);
        });
    });
  }

  override isEmpty() {
    return super.isEmpty() && !this.message;
  }

  override componentDescription() {
    return {
      focusable: true,
      type: CmsGrid,
      data: this,
    };
  }
}
